import { Box, Stack, Typography, useTheme } from "@mui/material";
import { useEffect, useState } from "react";
import PageBanner from "../components/application/PageBanner";
import useScreen from "../components/common/UseScreen";
import Faq from "../components/contact-us/Faq";
// import Faq from "../components/contact-us/Faq";
import { ContactUsText } from "../data/texts";
import { Images } from "../models/assets-files";
import { ContactUsService } from "../services/contact-us.service";
import { ImageService } from "../services/image.service";

import { AgentDetails } from "../components/contact-us/AgentDetails";
import { Owner } from "../types/owner";

const ContactUsPage = () => {
  const theme = useTheme();
  const [agent, setAgent] = useState<Owner>();
  const [isLoading, setIsLoading] = useState(true);

  const { isMobile } = useScreen();

  const fetchContactUsInfo = async () => {
    const response = await ContactUsService.getContactUsInfo();
    setIsLoading(false);
    if (response?.name === "Leads Pools") {
      setAgent({
        ...response,
        name: "Online Justice Support",
      });
    } else {
      setAgent(response);
    }
  };

  useEffect(() => {
    fetchContactUsInfo();
  }, []);

  return (
    <Stack
      sx={{
        padding: isMobile ? "0" : "24px",
        background: theme.palette.background.default,
      }}
      alignItems={"center"}
    >
      <PageBanner
        title={ContactUsText.CONTACT_US_BANNER_TITLE}
        imageSrc={ImageService.getLocalImgPath(
          Images.Folders.BANNERS,
          Images.Banners.LAPTOP_BIG,
          "png"
        )}
        containerSx={{ marginBottom: "20px" }}
      />
      <AgentDetails isLoading={isLoading} agent={agent} />
      <Faq sx={{ marginBottom: "40px" }} />
      {/* <Chip sx={{ marginBottom: "20px" }} label={ContactUsText.QUESTIONS} /> */}
      <Box sx={{ padding: isMobile ? "24px" : "0" }}>
        <Typography
          sx={{ fontSize: "20px", marginBottom: "10px", textAlign: "center" }}
        >
          {ContactUsText.STILL_QUESTION}
        </Typography>
        <Typography
          sx={{ fontWeight: "200", marginBottom: "40px", textAlign: "center" }}
        >
          {ContactUsText.STILL_QUESTION_SUBTITLE}
        </Typography>
      </Box>
    </Stack>
  );
};

export default ContactUsPage;
